import { Dayjs } from 'dayjs';

export type DeliveryRegistrationFormUi = {
  orderNumber?: string;
  deliveryTotalAmount: string;
  deliveryConfirmedDate: Dayjs | null;
  deliveryConfirmedTime: Dayjs | null;
  deliveryConfirmedNotes: string | null;
  appliedMercantoWarranty: boolean;
  deliveryOrderCompleted: boolean;
  deliveryOrderExtraProducts: boolean;
  deliveryProductPriceAdjusted: boolean;
  cancelDisabled?: boolean;
  saveDisabled?: boolean;
};

export const initialState: DeliveryRegistrationFormUi = {
  deliveryTotalAmount: '',
  deliveryConfirmedDate: null,
  deliveryConfirmedTime: null,
  deliveryConfirmedNotes: '',
  appliedMercantoWarranty: false,
  deliveryOrderCompleted: false,
  deliveryOrderExtraProducts: false,
  deliveryProductPriceAdjusted: false,
};
